import { SET_CUSTOMERS_VIEW } from "../types";

const initialState = {
  status: false,
  formStatus: false,
};

const isCustomersViewSelected = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOMERS_VIEW:
      return { ...state, status: action.status, formStatus: action.formStatus };
    default:
      return state;
  }
};

export default isCustomersViewSelected;
